import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { WellHealthinessService } from 'app/modules/well-healthiness/services/well-healthiness.service';
import { StringsHealthinessSummaryResponse } from 'app/modules/well-healthiness/model';
import module from 'app/modules/well-healthiness/well-healthiness.module';

@Component({
    selector: 'app-well-healthiness-info',
    templateUrl: './healthiness-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./healthiness-info.component.scss'],
})
export class HealthinessInfoComponent implements OnChanges {
    @Input() data: StringsHealthinessSummaryResponse;

    constructor(public service: WellHealthinessService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            // Handle data changes
        }
    }

    getTotalHealthy(): number {
        if (!this.data?.items || !Array.isArray(this.data.items)) {
            return 0;
        }

        const healthyItems = this.data.items.filter((item) => {
            const hasHealthy = item.category.includes('Healthy');
            const hasUnhealthy = item.category.includes('Unhealthy');
            return hasHealthy && !hasUnhealthy;
        });

        return healthyItems.reduce((sum, item) => sum + item.count, 0);
    }

    getTotalUnhealthy(): number {
        if (!this.data?.items || !Array.isArray(this.data.items)) {
            return 0;
        }

        const unhealthyItems = this.data.items.filter((item) =>
            item.category.includes('Unhealthy')
        );
        return unhealthyItems.reduce((sum, item) => sum + item.count, 0);
    }

    getOverallHealthyPercentage(): number {
        const healthy = this.getTotalHealthy();
        const unhealthy = this.getTotalUnhealthy();
        const total = healthy + unhealthy;

        if (total === 0) {
            return 0;
        }

        return Math.round((healthy / total) * 100);
    }
}
